import { defineStore } from 'pinia';
import { api } from '../boot/axios';
import { useApplicationStore } from './application';
import { NotFoundError } from 'src/services/errorHandlingService';

export const useStatsStore = defineStore('stats', {
  persist: true,

  state: () => ({
    telemedReport: null,
    telemedReportLoading: false,
  }),

  getters: {
    getTelemedReport: (state) => {
      return state.telemedReport;
    },
    getTelemedReportLoading: (state) => {
      return state.telemedReportLoading;
    },
  },

  actions: {
    async fetchCustomReport(criteria) {
      const appStore = useApplicationStore();
      if (!appStore.isOnline) {
        return [];
      }
      try {
        const response = await api.post('api/v1/stats/customreport', criteria);
        return response.data;
      } catch (err) {
        // A 404 used to arrive here as an empty response, which this action
        // reported as no rows. Keep that: the report pages show an empty
        // table rather than an error.
        if (err instanceof NotFoundError) {
          return [];
        }
        throw err;
      }
    },
    async fetchCallVolumeMonthly(criteria) {
      const appStore = useApplicationStore();
      if (!appStore.isOnline) {
        return [];
      }
      try {
        const response = criteria
          ? await api.post('/api/v1/stats/monthlycallvolume', criteria)
          : await api.get('/api/v1/stats/monthlycallvolume');
        return response.data;
      } catch (err) {
        // Same as fetchCustomReport - an empty chart, not an error.
        if (err instanceof NotFoundError) {
          return [];
        }
        throw err;
      }
    },
    async fetchLastThirtyDays() {
      const appStore = useApplicationStore();
      if (appStore.isOnline) {
        const response = await api.get('/api/v1/stats/last30days');
        return response.data;
      }
    },
    async fetchClientStats(criteria) {
      const appStore = useApplicationStore();
      if (!appStore.isOnline) {
        return;
      }
      this.telemedReportLoading = true;
      try {
        const response = criteria
          ? await api.post('/api/v1/stats/monthlyclientstats', criteria)
          : await api.get('/api/v1/stats/monthlyclientstats');
        return response.data;
      } finally {
        // Clear the flag even when the request failed. It is persisted, so a
        // value left at true strands the report spinner across reloads too.
        this.telemedReportLoading = false;
      }
    },
    async fetchClientSLA(criteria) {
      const appStore = useApplicationStore();
      if (appStore.isOnline) {
        let response;
        if (criteria) {
          response = await api.post('/api/v1/stats/clientsla', criteria);
        } else {
          response = await api.get('/api/v1/stats/clientsla');
        }
        return response.data;
      }
    },
    async fetchWorkflowStats() {
      const appStore = useApplicationStore();
      if (appStore.isOnline) {
        const response = await api.get('api/v1/stats/monthlyworkflowstats');
        return response.data;
      }
    },
  },
});
